import { IS_LOCAL_TEST } from '@/js/constants';

function resolveStore(target) {
  return target?.$store || target || {};
}

function removeUndefinedValues(payload = {}) {
  return Object.keys(payload).reduce((acc, key) => {
    if (payload[key] !== undefined) {
      acc[key] = payload[key];
    }
    return acc;
  }, {});
}

export function getSamplesRegisterAnalyticsContext(target) {
  const store = resolveStore(target);
  const state = store?.state || {};
  const getters = store?.getters || {};
  const authenticatedUser = state?.user?.authenticatedUser || {};
  const contact = state?.contact || {};
  const contactInfo = getters?.['contact/contactInfo'] || {};
  const language =
    authenticatedUser?.language_code ||
    authenticatedUser?.contacts?.[0]?.language;
  const companyCode =
    contact?.company ||
    authenticatedUser?.contacts?.[0]?.companies?.[0]?.code;
  const countryCode =
    contactInfo?.country ||
    (typeof companyCode === 'string' &&
    companyCode.trim().length >= 2
      ? companyCode.trim().substring(0, 2)
      : undefined);

  return removeUndefinedValues({
    company_code: companyCode || undefined,
    country_code: countryCode || undefined,
    user_language: language || undefined,
  });
}

export function emitSamplesRegisterGa4Event(
  target,
  eventName,
  eventParams = {}
) {
  if (IS_LOCAL_TEST || typeof window === 'undefined') return;

  window.gtag?.('event', eventName, {
    ...getSamplesRegisterAnalyticsContext(target),
    ...removeUndefinedValues(eventParams),
  });
}
